import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Badge, Col, Row, Spinner} from "react-bootstrap";
import Input from "../../../common/Input";
import {checkPermission, isEmpty} from "../../../../_helpers/commonFunctions";
import TextArea from "../../../common/TextArea";
import Button from "react-bootstrap/Button";
import {
    setActiveVisit, setActiveVisitClientData,
    setActiveVisitFirstLoad, setActiveVisitForceRefresh,
    setActiveVisitPrescriptions,
    setActiveVisitReferrals,
    setActiveVisitTreatmentProtocols, setActiveVisitTreatmentProtocolsSteps, setAutoPatientHistory,
    setDoctorTreatmentProtocols,
    setNewPrescription,
    setNewReferral,
} from "../../../../_reducers/DataPanel/Prescription/prescriptionSlice";
import moment from "moment";
import "./styles.css";
import axios from "axios";
import NewPrescriptionModal from "./Components/newPrescriptionModal";
import NewTreatmentProtocolModal from "./Components/newTreatmentProtocolModal";
import NewReferralModal from "./Components/newReferralModal";
import {setSaveActiveVisit} from "../../../../_reducers/activitySlice";
import BetterCheckBox from "../../../common/BetterCheckBox";
import {toast} from "react-toastify";
import BiometricsModal from "./Components/biometricsModal";
import CopyReferralModal from "./Components/copyReferralModal";
import CopyPrescriptionModal from "./Components/copyPrescriptionModal";
import Modal from "react-bootstrap/Modal";
import {bigTextComponent} from "./constants";
import ActiveTPModal from "./Components/activeTPModal";
import {
    downloadPrescription,
    downloadReferral, downloadVisitReferrals, openPrescription, openReferral,
    printPrescription,
    printReferral, printVisitReferrals,
    sendDigitally
} from "./prescriptionFunctions";
import PatientDetailsModal from "./Components/patientDetailsModal";
import VisitContactPoints from "./Components/visitContactPoints";
import {openClient, openTabByType} from "../../../../_helpers/tabOpeners";

const VisitActive = () => {
    const dispatch = useDispatch();
    const permissionsData = JSON.parse(localStorage.getItem("permissions"));
    const saveActiveVisit = useSelector((state) => state.ACTIVITY.saveActiveVisit);
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);
    const activeVisit = useSelector((state) => state.PRESCRIPTION.activeVisit);
    const activeVisitClientData = useSelector((state) => state.PRESCRIPTION.activeVisitClientData);
    const activeVisitFirstLoad = useSelector((state) => state.PRESCRIPTION.activeVisitFirstLoad);
    const activeVisitPrescriptions = useSelector((state) => state.PRESCRIPTION.activeVisitPrescriptions);
    const activeVisitTreatmentProtocols = useSelector((state) => state.PRESCRIPTION.activeVisitTreatmentProtocols); // All of patient's TP
    const activeVisitTreatmentProtocolsSteps = useSelector((state) => state.PRESCRIPTION.activeVisitTreatmentProtocolsSteps); // Steps in current visit
    const activeVisitReferrals = useSelector((state) => state.PRESCRIPTION.activeVisitReferrals);
    const activeVisitForceRefresh = useSelector((state) => state.PRESCRIPTION.activeVisitForceRefresh);

    const doctorTreatmentProtocols = useSelector((state) => state.PRESCRIPTION.doctorTreatmentProtocols);

    const [showBiometrics, setShowBiometrics] = useState(false);
    const [showPatientDetails, setShowPatientDetails] = useState(false);
    const [showNewPrescription, setShowNewPrescription] = useState(false);
    const [showNewTreatmentProtocol, setShowNewTreatmentProtocol] = useState(false);
    const [showNewReferral, setShowNewReferral] = useState(false);
    const [showCopyReferral, setShowCopyReferral] = useState(false);
    const [showCopyPrescription, setShowCopyPrescription] = useState(false);

    const [rememberCauseNotes, setRememberCauseNotes] = useState({
        visitCause: "",
        visitNotes: "",
    })
    const [editCauseNotes, setEditCauseNotes] = useState(false);
    const [loadingSaveCauseNotes, setLoadingSaveCauseNotes] = useState(false);

    const [loadingPrintReferrals, setLoadingPrintReferrals] = useState(false);

    const [showDeleteTPModal, setShowDeleteTPModal] = useState(false);
    const [toDeleteTP, setToDeleteTP] = useState(null);
    const [loadingDeleteTP, setLoadingDeleteTP] = useState(false);

    const [showDisableTPModal, setShowDisableTPModal] = useState(false);
    const [toDisableTP, setToDisableTP] = useState(null);
    const [loadingDisableTP, setLoadingDisableTP] = useState(false);

    const [showSelectedTP, setShowSelectedTP] = useState(false);
    const [selectedTP, setSelectedTP] = useState(null);
    const [preselectedTP, setPreselectedTP] = useState(null); // For "New step" button when selected active TP

    const [toDeleteTPSubstance, setToDeleteTPSubstance] = useState(null);
    const [showToDeleteTPSubstance, setShowToDeleteTPSubstance] = useState(false);
    const [loadingDeleteTPSubstance, setLoadingDeleteTPSubstance] = useState(false);

    useEffect(() => {
        if (!showDeleteTPModal) setToDeleteTP(null);
    }, [showDeleteTPModal])

    useEffect(() => {
        if (!showDisableTPModal) setToDisableTP(null);
    }, [showDisableTPModal])

    useEffect(() => {
        if (activeVisitFirstLoad) {
            dispatch(setSaveActiveVisit(true));
            dispatch(setActiveVisitFirstLoad(false));
            dispatch(setActiveVisitForceRefresh(false));
            fetchActiveVisitData();
            fetchPatientTreatmentProtocols();
        }
    }, [activeVisitFirstLoad]);

    useEffect(() => {
        if (activeVisitForceRefresh && !activeVisitFirstLoad) {
            dispatch(setActiveVisitForceRefresh(false));
            fetchActiveVisitData();
            if (activeVisitTreatmentProtocolsSteps.length > 0) {
                fetchPatientTreatmentProtocols();
            }
        }
    }, [activeVisitForceRefresh])

    useEffect(() => {
        if (doctorTreatmentProtocols.length === 0) fetchDoctorTreatmentProtocols();
    }, [activeVisit.visitId]);

    const fetchActiveVisitData = () => {
        axios.get(`${process.env.REACT_APP_API_URL2}/prescription/fetch-visit`, {
            headers: { 'Content-Type': 'application/json' },
            params: {
                company: company.id,
                id: activeVisit.visitId,
            }
        }).then((res) => {
            if (res.data.status === "200") {
                dispatch(setActiveVisitReferrals(res.data.data.referrals));
                dispatch(setActiveVisitPrescriptions(res.data.data.prescriptions));
            }
        }).catch((err) => {
            console.log(err)
        })
    }

    const fetchPatientTreatmentProtocols = () => {
        axios.get(`${process.env.REACT_APP_API_URL2}/prescription/patient-treatment-protocols`, {
            headers: { 'Content-Type': 'application/json' },
            params: {
                company: company.id,
                amka: activeVisit.amka,
                visitId: activeVisit.visitId,
            }
        }).then((res) => {
            if (res.data.status === "200") {
                dispatch(setActiveVisitTreatmentProtocols(res.data.data));
                if (res.data.dataCurrentVisit) dispatch(setActiveVisitTreatmentProtocolsSteps(res.data.dataCurrentVisit));
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    const fetchDoctorTreatmentProtocols = () => {
        axios.get(`${process.env.REACT_APP_API_URL2}/prescription/doctor-treatment-protocols`, {
            headers: { 'Content-Type': 'application/json' },
            params: {
                company: company.id,
            }
        }).then((res) => {
            if (res.data.status === "200") {
                dispatch(setDoctorTreatmentProtocols(res.data.data));
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    const onNewPrescription = () => {
        if (!saveActiveVisit) dispatch(setSaveActiveVisit(true));
        fetchActiveVisitData();
        if (activeVisitTreatmentProtocolsSteps.length > 0) {
            fetchPatientTreatmentProtocols();
        }
    }

    const onNewTreatmentProtocol = () => {
        if (!saveActiveVisit) dispatch(setSaveActiveVisit(true));
        fetchPatientTreatmentProtocols();
    }

    const onNewReferral = () => {
        if (!saveActiveVisit) dispatch(setSaveActiveVisit(true));
        fetchActiveVisitData();
    }

    const handleOnChange = (e, type, name) => {
        const prepChange = {};
        if (type === "cb") {
            if (name === "inQuota") {
                prepChange["inQuota"] = e.target.checked;
            }
        } else if (type === "input") {
            prepChange[name] = e.target.value;
        }
        dispatch(setActiveVisit({...activeVisit, ...prepChange}));
    }

    const handleSaveNewCauseNotes = () => {
        if (isEmpty(activeVisit.visitCause)) return toast.error("Παρακαλώ συμπληρώστε λόγο επίσκεψης.");

        setLoadingSaveCauseNotes(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/prescription/update-visit`, {
            company: company.id,
            visitId: activeVisit.visitId,
            visitCause: activeVisit.visitCause,
            visitNotes: activeVisit.visitNotes,
        }).then((res) => {
            if (res.data.status === "200") {
                setEditCauseNotes(false);
                toast.success("Επιτυχής αποθήκευση.");
            } else {
                toast.error(res.data.message);
            }
            setLoadingSaveCauseNotes(false);
        }).catch((err) => {
            setLoadingSaveCauseNotes(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const handleReferralCopy = (newReferral) => {
        setShowCopyReferral(false);
        setShowNewReferral(true);
        dispatch(setNewReferral(newReferral));
    }

    const handlePrescriptionCopy = (newPrescription) => {
        setShowCopyPrescription(false);
        setShowNewPrescription(true);
        dispatch(setNewPrescription(newPrescription));
    }

    const handleDeleteTP = () => {
        setLoadingDeleteTP(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/prescription/delete-treatment-protocol`, {
            company: company.id,
            id: toDeleteTP.id,
        }, {
            headers: { "Content-Type": "application/json" },
        }).then((res) => {
            if (res.data.status === "200") {
                toast.success("Επιτυχής διαγραφή θεραπευτικού πρωτοκόλλου.");
                setShowDeleteTPModal(false);
                setToDeleteTP(null);
                fetchPatientTreatmentProtocols();
            } else {
                toast.error(res.data.message);
            }
            setLoadingDeleteTP(false);
        }).catch((err) => {
            setLoadingDeleteTP(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const handleDisableTP = () => {
        setLoadingDisableTP(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/prescription/disable-treatment-protocol`, {
            company: company.id,
            id: toDisableTP.treatmentProtocol.id,
            amka: activeVisit.amka,
        }, {
            headers: { "Content-Type": "application/json" },
        }).then((res) => {
            if (res.data.status === "200") {
                toast.success("Επιτυχής απενεργοποίηση θεραπευτικού πρωτοκόλλου.");
                setShowDisableTPModal(false);
                setToDisableTP(null);
                fetchPatientTreatmentProtocols();
            } else {
                toast.error(res.data.message);
            }
            setLoadingDisableTP(false);
        }).catch((err) => {
            setLoadingDisableTP(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const handleOpenPatientHistory = () => {
        axios.get(process.env.REACT_APP_API_URL2 + `/client/get-client-id-by/${activeVisit.client}`, {
            headers: { "Content-Type": "application/json" },
        }).then((res) => {
            if (res.data.status === "200") {
                dispatch(setAutoPatientHistory(res.data.data));
                dispatch(openTabByType("patient-history", TABS_DATA));
            } else {
                toast.error("Σφάλμα κατά την άντληση ασθενή.");
            }
        }).catch((error) => {
            console.log(error);
            toast.error("Σφάλμα κατά την άντληση ασθενή.");
        })
    }

    const handleTPClick = (tp) => {
        setShowSelectedTP(true);
        setSelectedTP(tp);
    }

    const newTPStepCallback = (tp) => {
        setShowNewTreatmentProtocol(true);
        setPreselectedTP(tp?.treatmentProtocol?.id || null);
    }

    const handleDeleteTPSubstance = () => {
        setLoadingDeleteTPSubstance(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/prescription/cancel-tp-step`, {
            visitId: activeVisit.visitId,
            visitPastId: toDeleteTPSubstance.visitPastId,
            company: company.id,
        }).then((res) => {
            setLoadingDeleteTPSubstance(false);
            if (res.data.status === "200") {
                toast.success("Επιτυχής διαγραφή.");
                setToDeleteTPSubstance(null);
                setShowToDeleteTPSubstance(false);
                fetchPatientTreatmentProtocols();
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            setLoadingDeleteTPSubstance(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const handleOpenPatientCloud = () => {
        openClient(dispatch, TABS_DATA, company.id, activeVisit.client, 8);
    }

    return (
        <React.Fragment>
            <div style={{textAlign: "center"}}>
                <h5>Ενεργή Επίσκεψη : <strong>{activeVisit.visitId}</strong></h5>
            </div>
            <Row className={"mb-3"}>
                <Col md={5}>
                    <Row>
                        <Col md={11}>
                            <Input
                                label={"Ασθενής"}
                                name={"clientName"}
                                value={`${activeVisit.clientName} (${activeVisit.amka})`}
                                disabled={true}
                            />
                        </Col>
                    </Row>
                </Col>
            </Row>
            <div className={"mb-3 borderedContainer"}>
                <h5 style={{fontWeight: "600"}}>Πληροφορίες Ασθενή</h5>
                <Row className={"mb-2"}>
                    <Col md={3}>
                        <Input
                            label={"Ημερομηνία Γέννησης"}
                            value={moment(activeVisit.birthDate, "YYYYMMDD").format("DD/MM/YYYY")}
                            disabled={true}
                        />
                    </Col>
                    <Col md={3}>
                        <Input
                            label={"Οδός/Αριθμός"}
                            value={activeVisit.address}
                            disabled={true}
                        />
                    </Col>
                    <Col md={3}>
                        <Input
                            label={"Πόλη"}
                            value={activeVisit.city}
                            disabled={true}
                        />
                    </Col>
                    <Col md={3}>
                        <Input
                            label={"Ταχ. Κώδικας"}
                            value={activeVisit.postalCode}
                            disabled={true}
                        />
                    </Col>
                </Row>
                <Row className={"mb-2"}>
                    <Col md={3}>
                        <Input
                            label={"Τηλέφωνο"}
                            value={activeVisit.telephone}
                            disabled={true}
                        />
                    </Col>
                    <Col md={3}>
                        <Input
                            label={"Φύλο"}
                            value={activeVisit.sex === "male" ? "Άρρεν" : "Θήλυ"}
                            disabled={true}
                        />
                    </Col>
                    <Col md={3}>
                        <Input
                            label={"Άυλη Συνταγογράφηση"}
                            value={activeVisit?.noPaperConstent === "true" ? "Ναι" : "Όχι"}
                            disabled={true}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <Button size={"sm"} onClick={() => setShowBiometrics(true)}>Βιομετρικά</Button>
                        <Button size={"sm"} onClick={() => setShowPatientDetails(true)} className={"ml-1"}>Δεδομένα ασθενη (ΗΔΙΚΑ)</Button>
                        <Button size={"sm"} onClick={() => handleOpenPatientHistory()} className={"ml-1"}>Προβολή ιστορικού ασθενή</Button>
                        {checkPermission("clients-clients/edit-cloud-read", permissionsData) === true && (
                            <Button size={"sm"} onClick={() => handleOpenPatientCloud()} className={"ml-1"}>Προβολή αποθηκευμένων αρχείων ασθενή</Button>
                        )}
                    </Col>
                </Row>
                <VisitContactPoints clientData={activeVisitClientData} setClientData={(data) => dispatch(setActiveVisitClientData(data))} />
            </div>

            <div className={"mb-3 borderedContainer"}>
                <h5 style={{fontWeight: "600"}}>Πληροφορίες Επίσκεψης</h5>
                <Row>
                    <Col md={6}>
                        <TextArea
                            name={"visitCause"}
                            label={"Λόγος Επίσκεψης"}
                            value={activeVisit.visitCause}
                            required={true}
                            disabled={!editCauseNotes || loadingSaveCauseNotes}
                            rows={4}
                            limit={2000}
                            onChange={(e) => handleOnChange(e, "input", "visitCause")}
                        />
                    </Col>
                    <Col md={6}>
                        <TextArea
                            name={"visitNotes"}
                            label={"Σημειώσεις"}
                            value={activeVisit.visitNotes}
                            disabled={!editCauseNotes || loadingSaveCauseNotes}
                            rows={4}
                            limit={2000}
                            onChange={(e) => handleOnChange(e, "input", "visitNotes")}
                        />
                    </Col>
                </Row>
                <Row className={"d-flex justify-content-end"}>
                    <Col md={12} className={"d-flex justify-content-end"}>
                        {!editCauseNotes ? (
                            <Button size={"sm"} onClick={() => {
                                setEditCauseNotes(true);
                                setRememberCauseNotes({
                                    visitCause: activeVisit.visitCause,
                                    visitNotes: activeVisit.visitNotes
                                })
                            }}>Τροποποίηση</Button>
                        ) : (
                            <React.Fragment>
                                <Button size={"sm"} className={"mr-1"} onClick={() => {
                                    setEditCauseNotes(false);
                                    dispatch(setActiveVisit({...activeVisit, visitCause: rememberCauseNotes.visitCause, visitNotes: rememberCauseNotes.visitNotes}));
                                }} disabled={loadingSaveCauseNotes}>Ακύρωση</Button>
                                <Button size={"sm"} onClick={() => handleSaveNewCauseNotes()} disabled={loadingSaveCauseNotes}>
                                    Αποθήκευση {loadingSaveCauseNotes && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                                </Button>
                            </React.Fragment>
                        )}
                    </Col>
                </Row>
            </div>

            <div className={"mb-3 borderedContainer"}>
                <h5 style={{fontWeight: "600"}}>Ενέργειες στα πλαίσια της επίσκεψης</h5>
                <Button size={"sm"} onClick={() => setShowNewPrescription(true)}>+ Νέα συνταγή</Button>
                <Button size={"sm"} className={"ml-1"} onClick={() => setShowCopyPrescription(true)}>+ Νέα συνταγή από αντιγραφή</Button>
                <div className={"ml-2 vr mr-2"}></div>
                <Button size={"sm"} className={"ml-1"} onClick={() => setShowNewReferral(true)}>+ Νέο παραπεμπτικό</Button>
                <Button size={"sm"} className={"ml-1"} onClick={() => setShowCopyReferral(true)}>+ Νέο παραπεμπτικό από αντιγραφή</Button>
                <div className={"ml-2 vr mr-2"}></div>
                <Button size={"sm"} className={"ml-1"} onClick={() => setShowNewTreatmentProtocol(true)}>+ Νέο θεραπευτικό πρωτόκολλο</Button>
            </div>

            <div className={"mb-3 borderedContainer"} hidden={activeVisitPrescriptions.length === 0}>
                <h5 style={{fontWeight: "600"}}>Συνταγές</h5>
                {activeVisitPrescriptions.length > 0 && (
                    <table className={"simpleClassicTable prescriptionTable"}>
                        <colgroup>
                            <col span={1} style={{width: "20%"}}></col>
                            <col span={1} style={{width: "20%"}}></col>
                            <col span={1} style={{width: "20%"}}></col>
                            <col span={1} style={{width: "25%"}}></col>
                            <col span={1} style={{width: "15%"}}></col>
                        </colgroup>
                        <thead>
                        <tr>
                            <th>Αρ. Συνταγής</th>
                            <th>Ημερομηνία Έκδοσης</th>
                            <th>Ημερομηνία Λήξης</th>
                            <th>Κατάσταση</th>
                            <th>Ενέργειες</th>
                        </tr>
                        </thead>
                        <tbody>
                        {activeVisitPrescriptions.map((prescription, idx) => (
                            <tr key={`prescriptions-${idx}`} onClick={() => dispatch(openPrescription(prescription.prescriptionId, TABS_DATA))}>
                                <td>{prescription.prescriptionId}</td>
                                <td>{prescription.startDate}</td>
                                <td>{prescription.endDate}</td>
                                <td>{prescription.status}</td>
                                <td>
                                    <Badge bg={"primary"} onClick={(e) => {
                                        e.stopPropagation();
                                        printPrescription(prescription.prescriptionId, null, company);
                                        toast.info("Γίνεται εκτύπωση...");
                                    }} title={"Εκτύπωση Συνταγής"} style={{padding: "5px", fontSize: "16px"}}><i className="fa-solid fa-print"></i></Badge>
                                    <Badge bg={"primary"} className={"ml-1"} onClick={(e) => {
                                        e.stopPropagation();
                                        downloadPrescription(prescription.prescriptionId, null, company);
                                        toast.info("Γίνεται λήψη...");
                                    }} title={"Λήψη PDF"} style={{padding: "5px", fontSize: "16px"}}><i
                                        className="fa-solid fa-download"></i></Badge>
                                    {activeVisit.noPaperConstent === "true" && (
                                        <React.Fragment>
                                            <Badge bg={"primary"} className={"ml-1"} onClick={(e) => {
                                                e.stopPropagation();
                                                sendDigitally("prescriptions", prescription.prescriptionId, null, company);
                                            }} title={"Αποστολή σε ηλ/κή μορφή"} style={{padding: "5px", fontSize: "16px"}}><i className="fa-solid fa-paper-plane"></i></Badge>
                                        </React.Fragment>
                                    )}
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                )}
            </div>

            <div className={"mb-3 borderedContainer"} hidden={activeVisitReferrals.length === 0}>
                <h5 style={{fontWeight: "600"}}>Παραπεμπτικά</h5>
                {activeVisitReferrals.length > 0 && (
                    <React.Fragment>
                        <table className={"simpleClassicTable prescriptionTable"}>
                            <colgroup>
                                <col span={1} style={{width: "20%"}}></col>
                                <col span={1} style={{width: "20%"}}></col>
                                <col span={1} style={{width: "20%"}}></col>
                                <col span={1} style={{width: "25%"}}></col>
                                <col span={1} style={{width: "15%"}}></col>
                            </colgroup>
                            <thead>
                            <tr>
                                <th>Αρ. Παραπεμπτικού</th>
                                <th>Ημερομηνία Έκδοσης</th>
                                <th>Ημερομηνία Λήξης</th>
                                <th>Κατάσταση</th>
                                <th>Ενέργειες</th>
                            </tr>
                            </thead>
                            <tbody>
                            {activeVisitReferrals.map((referral, idx) => (
                                <tr key={`referrals-${idx}`} onClick={() => dispatch(openReferral(referral.referralId, TABS_DATA))}>
                                    <td>{referral.referralId}</td>
                                    <td>{referral.startDate}</td>
                                    <td>{referral.endDate}</td>
                                    <td>{referral.status}</td>
                                    <td>
                                        <Badge bg={"primary"} onClick={(e) => {
                                            e.stopPropagation();
                                            printReferral(referral.referralId, null, company);
                                            toast.info("Γίνεται εκτύπωση...");
                                        }} title={"Εκτύπωση Παραπεμπτικού"} style={{padding: "5px", fontSize: "16px"}}><i className="fa-solid fa-print"></i></Badge>
                                        <Badge bg={"primary"} className={"ml-1"} onClick={(e) => {
                                            e.stopPropagation();
                                            downloadReferral(referral.referralId, null, company);
                                            toast.info("Γίνεται λήψη...");
                                        }} title={"Λήψη PDF"} style={{padding: "5px", fontSize: "16px"}}><i
                                            className="fa-solid fa-download"></i></Badge>
                                        {activeVisit.noPaperConstent === "true" && (
                                            <React.Fragment>
                                                <Badge bg={"primary"} className={"ml-1"} onClick={(e) => {
                                                    e.stopPropagation();
                                                    sendDigitally("referrals", referral.referralId, null, company);
                                                }} title={"Αποστολή σε ηλ/κή μορφή"} style={{padding: "5px", fontSize: "16px"}}><i className="fa-solid fa-paper-plane"></i></Badge>
                                            </React.Fragment>
                                        )}
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                        <Button size={"sm"} className={"mt-2"} onClick={() => printVisitReferrals(activeVisit.visitId, setLoadingPrintReferrals, company)} disabled={loadingPrintReferrals}>
                            Εκτύπωση παραπεμπτικών
                        </Button>
                        <Button size={"sm"} className={"ml-1 mt-2"} onClick={() => downloadVisitReferrals(activeVisit.visitId, setLoadingPrintReferrals, company)} disabled={loadingPrintReferrals}>
                            Λήψη παραπεμπτικών σε .PDF
                        </Button>
                    </React.Fragment>
                )}
            </div>

            <div className={"mb-3 borderedContainer"} hidden={activeVisitTreatmentProtocolsSteps.length === 0}>
                <h5 style={{fontWeight: "600"}}>Θεραπευτικά Πρωτόκολλα Επίσκεψης</h5>
                {activeVisitTreatmentProtocolsSteps.length > 0 && (
                    <table className={"simpleClassicTable"}>
                        <colgroup>
                            <col span={1} style={{width: "40%"}}></col>
                            <col span={1} style={{width: "30%"}}></col>
                            <col span={1} style={{width: "15%"}}></col>
                            <col span={1} style={{width: "15%"}}></col>
                        </colgroup>
                        <thead>
                        <tr>
                            <th>Θεραπευτικό Πρωτόκολλο / Βήμα Εισαγωγής</th>
                            <th>Δραστική Ουσία (ATC5)</th>
                            <th>Έχει χρησιμοποιηθεί</th>
                            <th>Ενέργειες</th>
                        </tr>
                        </thead>
                        <tbody>
                        {activeVisitTreatmentProtocolsSteps.map((row, idx) => (
                            <tr key={`activeTPSteps-${idx}`}>
                                <td>{row.description}</td>
                                <td>{row?.activeSubstance?.description} ({row?.atcCode}) {row.content ? ` - ${row.content}` : ""}</td>
                                <td>{row.treatmentInserted === "true" ? "Ναι" : "Όχι"}</td>
                                <td>
                                    <Badge bg={"danger"} onClick={(e) => {
                                        e.stopPropagation();
                                        setToDeleteTPSubstance(row);
                                        setShowToDeleteTPSubstance(true);
                                    }} style={{cursor: "pointer"}}>
                                        Διαγραφή
                                    </Badge>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                )}
            </div>

            <div className={"mb-3 borderedContainer"} hidden={activeVisitTreatmentProtocols.length === 0}>
                <h5 style={{fontWeight: "600"}}>Θεραπευτικά Πρωτόκολλα Ασθενή</h5>
                {activeVisitTreatmentProtocols.length > 0 && (
                    <table className={"simpleClassicTable prescriptionTable"}>
                        <thead>
                        <tr>
                            <th>Θεραπευτικό Πρωτόκολλο</th>
                            <th>Ημ/νία Ένταξης στο Πρωτόκολλο</th>
                            <th>MDC</th>
                            <th>Περιγραφή</th>
                            <th>Ημ/νία Τελευταίας Συνταγ/σης</th>
                            <th>Κατάσταση</th>
                            <th>Ενέργειες</th>
                        </tr>
                        </thead>
                        <tbody>
                        {activeVisitTreatmentProtocols.map((tp, idx) => (
                            <tr key={`treatmentProtocols-${idx}`} onClick={() => handleTPClick(tp)}>
                                <td>{tp?.treatmentProtocol?.code} - {tp?.treatmentProtocol?.title}</td>
                                <td>{moment(tp?.insertDate, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY")}</td>
                                <td>{tp?.treatmentProtocol?.mdc.description}</td>
                                <td>{bigTextComponent(tp?.treatmentProtocol?.description)}</td>
                                <td>{tp?.lastUsedDate ? moment(tp?.lastUsedDate, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY") : "-"}</td>
                                <td>{tp.active === "true" ? <Badge bg={"success"}>Ενεργό</Badge> : <Badge bg={"danger"}>Ανενεργό</Badge>}</td>
                                <td>
                                    {tp.active === "true" && (
                                        <Badge bg={"dark"} className={"mr-1"} style={{cursor: "pointer"}} onClick={(e) => {
                                            e.stopPropagation();
                                            setShowDisableTPModal(true);
                                            setToDisableTP(tp);
                                        }}>Απενεργοποίηση</Badge>
                                    )}
                                    <Badge bg={"danger"} style={{cursor: "pointer"}} onClick={(e) => {
                                        e.stopPropagation();
                                        setShowDeleteTPModal(true);
                                        setToDeleteTP(tp);
                                    }}>Διαγραφή</Badge>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                )}
            </div>

            <div className={"mb-3 borderedContainer"}>
                <h5 style={{fontWeight: "600"}}>Λοιπά</h5>
                <Row>
                    <Col md={6}>
                        <BetterCheckBox
                            name={"inQuota"}
                            className={"mb-0"}
                            text={`Να υπολογιστεί η επίσκεψη στο όριο επισκέψεων ${!isEmpty(activeVisit.payableMessage) ? `(${activeVisit?.payableMessage})` : ""}`}
                            checked={activeVisit.inQuota}
                            disabled={activeVisit.payable === false}
                            onChange={(e) => handleOnChange(e, "cb", "inQuota")}
                        />
                    </Col>
                </Row>
            </div>

            <Modal show={showDeleteTPModal} onHide={() => setShowDeleteTPModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Διαγραφή Θεραπευτικού Πρωτοκόλλου</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {toDeleteTP !== null && (
                        <React.Fragment>
                            Είσαστε σίγουροι ότι θέλετε να διαγράψετε το θεραπευτικό πρωτόκολλο {toDeleteTP?.treatmentProtocol?.code} - {toDeleteTP?.treatmentProtocol?.title} του ασθενή {activeVisit.clientName} με ΑΜΚΑ {activeVisit.amka};
                        </React.Fragment>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => handleDeleteTP()} disabled={loadingDeleteTP}>
                        Ναι, διαγραφή {loadingDeleteTP && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showDisableTPModal} onHide={() => setShowDisableTPModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Απενεργοποίηση Θεραπευτικού Πρωτοκόλλου</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {toDisableTP !== null && (
                        <React.Fragment>
                            Είσαστε σίγουροι ότι θέλετε να απενεργοποιήσετε το θεραπευτικό πρωτόκολλο {toDisableTP?.treatmentProtocol?.code} - {toDisableTP?.treatmentProtocol?.title} του ασθενή {activeVisit.clientName} με ΑΜΚΑ {activeVisit.amka};<br/>
                            Η απενεργοποίηση γίνεται μόνο σε ορισμένα Θεραπευτικά Πρωτόκολλα και ενδέχεται να μην πραγματοποιηθεί για το παρόν.
                        </React.Fragment>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => handleDisableTP()} disabled={loadingDisableTP}>
                        Ναι, απενεργοποίηση {loadingDisableTP && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showToDeleteTPSubstance} onHide={() => setShowToDeleteTPSubstance(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Προσοχή</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Είστε σίγουροι ότι θέλετε να αφαιρέσετε τη συγκεκριμένη Δραστική Ουσία από τις επιλεγμένες;
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setShowToDeleteTPSubstance(false)}>
                        Ακύρωση
                    </Button>
                    <Button variant="primary" onClick={() => handleDeleteTPSubstance()} disabled={loadingDeleteTPSubstance}>
                        Διαγραφή {loadingDeleteTPSubstance && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                    </Button>
                </Modal.Footer>
            </Modal>

            <NewPrescriptionModal
                show={showNewPrescription}
                setShow={setShowNewPrescription}
                successCallback={() => onNewPrescription()}
                noPaperConstent={activeVisit.noPaperConstent}
                amka={activeVisit.amka}
                ekasLoss={activeVisit.ekasLoss}
                activePartException={activeVisit.activePartException}
                activeVisitTreatmentProtocols={activeVisitTreatmentProtocols}
                activeVisitTreatmentProtocolsSteps={activeVisitTreatmentProtocolsSteps}
            />
            <NewReferralModal
                show={showNewReferral}
                setShow={setShowNewReferral}
                successCallback={() => onNewReferral()}
                noPaperConstent={activeVisit.noPaperConstent}
                ekasLoss={activeVisit.ekasLoss}
                activePartException={activeVisit.activePartException}
            />
            <NewTreatmentProtocolModal
                show={showNewTreatmentProtocol}
                setShow={setShowNewTreatmentProtocol}
                successCallback={() => onNewTreatmentProtocol()}
                existingProtocols={activeVisitTreatmentProtocols}
                preselectedTP={preselectedTP}
                setPreselectedTP={setPreselectedTP}
            />
            <ActiveTPModal
                show={showSelectedTP}
                setShow={setShowSelectedTP}
                selectedTP={selectedTP}
                setSelectedTP={setSelectedTP}
                newStepCallback={(tp) => newTPStepCallback(tp)} // Open new treatment protocol
                repeatStepCallback={() => fetchPatientTreatmentProtocols()}
            />
            <BiometricsModal
                show={showBiometrics}
                setShow={setShowBiometrics}
                amka={activeVisit.amka}
            />
            <CopyReferralModal
                show={showCopyReferral}
                setShow={setShowCopyReferral}
                referralCallback={(newReferral) => handleReferralCopy(newReferral)}
                amka={activeVisit.amka}
            />
            <CopyPrescriptionModal
                show={showCopyPrescription}
                setShow={setShowCopyPrescription}
                prescriptionCallback={(newPrescription) => handlePrescriptionCopy(newPrescription)}
                amka={activeVisit.amka}
            />
            <PatientDetailsModal
                show={showPatientDetails}
                setShow={setShowPatientDetails}
                amka={activeVisit.amka}
                disabled={true}
            />
        </React.Fragment>
    )
}

export default VisitActive
